interface IBuildCourseUrlParams {
  subscriptionId: string;
  activityId?: string;
  planItemId?: string;
  fromPath?: string;
  isPlanificationFlow?: boolean;
  showPlanificationIntro?: boolean;
}

export const buildCourseUrl = ({
  subscriptionId,
  activityId,
  planItemId,
  fromPath,
  isPlanificationFlow = false,
  showPlanificationIntro = true
}: IBuildCourseUrlParams) => {
  const params = new URLSearchParams();
  if (activityId) params.set('activity', activityId);
  if (planItemId) params.set('planItemId', planItemId);
  if (isPlanificationFlow) params.set('isPlanificationFlow', 'true');
  if (fromPath) params.set('from', fromPath);
  if (showPlanificationIntro) params.set('showPlanificationIntro', 'true');

  return `/subscription/${subscriptionId}?${params.toString()}`;
};
